import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TeleportToDirective } from './teleport.directive';
import { GooglePlacesDirective } from './index';

/**
 * Module for all the directives
 */
@NgModule({
  declarations: [
    GooglePlacesDirective,
    TeleportToDirective
  ],
  exports: [
    GooglePlacesDirective,
    TeleportToDirective
  ],
  imports: [
    CommonModule
  ]
})
export class DirectivesModule { }
